/**
 * Processor Data Processing Agreement — display component (PDPL).
 *
 * Shown to the org owner in the DPA-acceptance modal (see DpaBanner). Uses
 * explicit light colors so it renders correctly inside the dark dashboard shell.
 * Keep in sync with docs/pdpl/dpa-template.md and `settings.DPA_VERSION`.
 */
const VERSION = '2026-06-16'

type Section = { heading: string; body: string[] }

const SECTIONS: Section[] = [
  { heading: '1. Parties & subject matter', body: [
    'This agreement governs how WeTook (the "Processor") processes the personal data of your customers (the "Controller" being your organization). It applies for the duration of your use of the service.',
  ]},
  { heading: '2. Nature & purpose', body: [
    'WeTook processes customer personal data only to provide the platform — digital menus, signage, storefront ordering, customer authentication (WhatsApp OTP), and notifications — as configured by you.',
  ]},
  { heading: '3. Data covered', body: [
    'Data subjects: your end customers (and individuals appearing in uploaded content).',
    'Personal data: name, phone, email, optional birth date / gender, vehicle details, order history, free-text notes, and media that may depict individuals.',
  ]},
  { heading: '4. Our obligations as Processor', body: [
    'Process only on your documented instructions; keep staff bound to confidentiality; apply appropriate security measures (encryption in transit, access control, token revocation, audit logging, private media storage).',
    'Use only the approved sub-processors below, under equivalent obligations; assist you with data-subject requests (export / erase / correct are built in) and with breach handling; on termination, delete or return the data (subject to legal-retention exceptions).',
  ]},
  { heading: '5. Breach notification', body: [
    'We notify you without undue delay after becoming aware of a personal data breach affecting your data.',
  ]},
  { heading: '6. International transfers', body: [
    'Processing and some sub-processing occur outside the Kingdom of Saudi Arabia. We apply safeguards consistent with the PDPL (transfer risk assessment, standard contractual clauses, and data minimization).',
  ]},
  { heading: '7. Approved sub-processors', body: [
    'Railway (hosting), Cloudflare (media storage + CDN), AWS (email; legacy media), Meta (WhatsApp messaging), Google (staff sign-in).',
  ]},
  { heading: '8. Governing law', body: [
    'Governed by the laws of the Kingdom of Saudi Arabia and the Personal Data Protection Law, alongside your service agreement.',
  ]},
]

export default function DataProcessingAgreement() {
  return (
    <div className="bg-white px-6 py-6 text-gray-900">
      <h1 className="text-xl font-black tracking-tight">Data Processing Agreement</h1>
      <p className="mb-5 mt-1 text-xs text-gray-500">Version {VERSION}</p>
      <div className="space-y-5">
        {SECTIONS.map((s, i) => (
          <section key={i}>
            <h2 className="mb-1 text-sm font-bold text-gray-900">{s.heading}</h2>
            {s.body.map((p, j) => (
              <p key={j} className="mb-1.5 text-sm leading-relaxed text-gray-600">{p}</p>
            ))}
          </section>
        ))}
      </div>
    </div>
  )
}
